import { Prefix, SearchType } from '@/types'
import { exists } from '@/api'

export interface BibliographyRealDetailContent {
  prefix: Prefix
  bibliographyId: number
  searchType: SearchType
  displayTitle: string
  displayAuthor: string
  bibliographyRealId: number
  serial: number
  revision: number
}

export function BibliographyRealDetailContentFromJSON(
  json: any
): BibliographyRealDetailContent {
  return {
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? json.search_type
      : SearchType.Book,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    serial: exists(json, 'serial') ? json.serial : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}

export function defaultBibliographyRealDetailContent(): BibliographyRealDetailContent {
  return {
    prefix: Prefix.Real,
    bibliographyId: 0,
    searchType: SearchType.Book,
    displayTitle: '',
    displayAuthor: '',
    bibliographyRealId: 0,
    serial: 0,
    revision: 0
  }
}
